import React from 'react';
import styles from './PlatformTag.module.css';

interface PlatformTagProps {
  platform: string;
}

export const PlatformTag: React.FC<PlatformTagProps> = ({ platform }) => {
  const getPlatformColor = (platform: string) => {
    switch (platform) {
      case 'SCRATCH':
        return '#FFA500';
      case 'MICROBIT':
        return '#00D4AA';
      default:
        return '#6B7280';
    }
  };

  const formatPlatformName = (platform: string) => {
    switch (platform) {
      case 'SCRATCH':
        return 'Scratch';
      case 'MICROBIT':
        return 'micro:bit';
      default:
        return platform;
    }
  };

  return (
    <span className={styles.platformLabel} style={{ backgroundColor: getPlatformColor(platform) }}>
      {formatPlatformName(platform)}
    </span>
  );
};
